import type { SvgIconProps } from '@mui/material';
import type { FieldElement } from '../../format/form-definition';
import { elementType } from '../fieldsPalette/tiles';

export const FieldIcon = ({ field, ...props }: { field: FieldElement } & SvgIconProps) => {
  const { icon: Icon } = elementType(field);
  return <Icon {...props} />;
};
